import script from "./ExerciseGreedyGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExerciseGreedyGraph.vue?vue&type=script&setup=true&lang=ts"

import "./ExerciseGreedyGraph.vue?vue&type=style&index=0&id=294a2e9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294a2e9e"]])

export default __exports__